/* make webpack css processing work* */

require('./partials/gallery.js');
require('./partials/navigation.js');
require('./partials/ui.js');